export const pos = {
  hero: {
    title: {
      pt1: 'A',
      pt2: 'plug-and-play POS',
      pt3: 'device for order handling'
    },
    description: 'The only device you need to receive your orders. Receive, manage and print. All from one portable device. '
  },
  paragraphs: {
    paragraph_1: {
      title: 'Plug & play, serve all day',
      text: 'No difficult setup, just switch on and serve. Start accepting orders in minutes. ',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_2: {
      title: 'Accept orders & print receipts',
      text: 'With the Bistroo POS everything is managed from one device. No extra printer needed, everything is built in. ',
      cta: ''
    },
    paragraph_3: {
      title: 'Freedom to serve. Anywhere, anytime. ',
      text: 'Inside or outside, with WiFi and SIM you can accept orders at any location. You are always online. ',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_4: {
      title: 'No cables, no chaos',
      text: 'Fully wireless with long battery life, stay unplugged and remove the cables from your kitchen floor. ',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Order management software.',
        text: 'Real-time order management for keeping overview of your orders and process',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Know what you earn.',
        text: 'View your revenue for an given period with one simple click',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Time is in your hands.',
        text: 'Manage your time slots effortlessly to prevent bottlenecks in the kitchen and optimize your flow',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Out of stock, no problem.',
        text: 'Manage your products inventory real time with one click',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Distribution settings.',
        text: 'Change your distribution settings real time and adjust them quickly',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"Bistroo thinks along with us in terms of solutions and new opportunities."',
    cta: 'Read Il Municipio\'s story',
    name: 'Il Municipio',
    job_title: 'Italian Restaurant'
  }
}